import { get, chain } from "lodash"
import { createSelector } from "reselect"
import { getIsSuperuser } from "modules/account-root/selectors"
import { getRoute, getPath } from "selectors/urls"
import { computeDatasetPermissionsTabs } from "helpers/permissions/tabs"

function isDirectMember(entitlement) {
  return get(entitlement, "direct") && get(entitlement, "member")
}

export const getDatasetMembers = (state) => chain(state)
  .get("global.data.datasetEntitlements.data")
  .filter(isDirectMember)
  .map("member")
  .value()

export const getMembers = (_, props) => get(props, "members.members")

export const getTabs = createSelector(
  [getRoute, getPath, getIsSuperuser],
  computeDatasetPermissionsTabs,
)
